import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["containerCSSStyles", "contentCSSStyles", "children", "ContentWrapper", "InnerWrapper", "OuterWrapper", "spec", "Template"];
import styled from 'foundations-theming/utils';
import { toScaledPercentage } from './deviceConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledDefaultOuterWrapper = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__StyledDefaultOuterWrapper"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
const StyledDisplayWrapper = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__StyledDisplayWrapper"
})(() => {
  return {
    borderRadius: 'inherit',
    display: 'grid',
    blockSize: '100%',
    position: 'relative',
    inlineSize: '100%',
    '> *': {
      gridArea: '1/1/2/2'
    }
  };
});
export const StyledDefaultInnerWrapper = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__StyledDefaultInnerWrapper"
})(({
  $dimensions,
  $cssStyles
}) => {
  return Object.assign({
    marginBlockEnd: toScaledPercentage($dimensions, 'bottom'),
    marginInlineStart: toScaledPercentage($dimensions, 'left'),
    marginInlineEnd: toScaledPercentage($dimensions, 'right'),
    marginBlockStart: toScaledPercentage($dimensions, 'top'),
    /* the following are all needed for IE11 */
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    position: 'relative'
  }, $cssStyles);
});
export const StyledDefaultContentWrapper = styled.div.withConfig({
  displayName: "AbstractDeviceFrame__StyledDefaultContentWrapper"
})(({
  $cssStyles
}) => {
  return Object.assign({
    '-ms-overflow-style': '-ms-autohiding-scrollbar',
    overflowY: 'auto',
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  }, $cssStyles);
});
export const AbstractDeviceFrame = _ref => {
  let {
      containerCSSStyles,
      contentCSSStyles,
      children,
      ContentWrapper,
      InnerWrapper,
      OuterWrapper,
      spec,
      Template
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const renderedTemplate = spec && spec.Template;
  return /*#__PURE__*/_jsx(OuterWrapper, Object.assign({}, rest, {
    containerCSSStyles: containerCSSStyles,
    children: /*#__PURE__*/_jsxs(StyledDisplayWrapper, {
      children: [/*#__PURE__*/_jsx(Template, {
        dimensions: spec,
        containerCSSStyles: containerCSSStyles,
        Template: renderedTemplate
      }), /*#__PURE__*/_jsx(InnerWrapper, {
        dimensions: spec,
        containerCSSStyles: containerCSSStyles,
        children: /*#__PURE__*/_jsx(ContentWrapper, {
          contentCSSStyles: contentCSSStyles,
          dimensions: spec,
          children: children
        })
      })]
    })
  }));
};